export default __webpack_public_path__ + "static/media/attendance.9a926b3b.svg";